import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  allEntHorBloquesAction,
  setActivoEntHorBloquesAction,
} from './EntHorBloquesAction';
import FormEntHorBloques from './components/FormEntHorBloques';
import ListadoEntHorBloques from './components/ListadoEntHorBloques';

const EntHorBloquesView = () => {
  const dispatch = Redux.useDispatch();

  const entHorBloquesStore = Redux.useSelector((state) => state.entHorBloques);

  const [isDelete, setIsDelete] = React.useState(false);

  return (
    <Grid container spacing={2}>
      <Grid item md={4}>
        <FormEntHorBloques isDelete={isDelete} />
      </Grid>
      <Grid item md={8}>
        <BotonComponent
          click={async () => {
            await setActivoEntHorBloquesAction(dispatch, null);
            await allEntHorBloquesAction(
              dispatch,

              entHorBloquesStore.params,
            );
          }}
          disabled={
            entHorBloquesStore.all.length === 0 && entHorBloquesStore.loadingAll
          }
          white
          refreshIcon
          text={
            entHorBloquesStore.loadingAll ? 'Actualizando...' : 'Actualizar'
          }
        />
        <ListadoEntHorBloques
          isDelete={isDelete}
          setIsDelete={(v) => setIsDelete(v)}
        />
      </Grid>
    </Grid>
  );
};

export default EntHorBloquesView;
